//@ts-check

class AuditsCaptureService {
	constructor($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) {
		this.$http = $http;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

    init() {
        this.auditTokenHistory = {};
        this.auditsHeaderDetails = {};
        this.auditsQueryLogs = {};
        this.auditorHeaderDetails = {};
        this.auditorContactDetails = {};
        this.auditsFile = {};
        this.listOfAssignees = [];
        this.auditsMessages = [];
        this.uploadedDocs = [];
    }

    async getAuditsTokenHistoryByCorrelationId(correlationId) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!correlationId) {
                throw new Error('Correlation Id must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditsTokenHistory');

            if (!url) {
                
                url = await this.InternalLinksService.getLink('GetAuditsTokenHistory');
            }
            url = `${url}?correlationId=${correlationId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            console.log(data);
            this.auditTokenHistory = this._map(data);

            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditTokenHistory = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getAuditsHeaderByFinancialPeriodHeaderId(financialPeriodHeaderId, db_Ref) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!financialPeriodHeaderId) {
                throw new Error('financialPeriodHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditsHeaderDetails');

            if (!url) {

                url = await this.InternalLinksService.getLink('GetAuditsHeaderDetails');
            }
            url = `${url}?financialPeriodHeaderId=${financialPeriodHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.auditsHeaderDetails = this._map(data);
            
            this.getAuditorContactDetailsByAuditorHeaderId(this.auditsHeaderDetails.AuditorHeaderId);
            var auditorHeaderId = this.auditsHeaderDetails.AuditorHeaderId;
            this.getAuditorByAuditorHeaderId(auditorHeaderId);

            await this.InternalLinksService.getLinks('audits/links', false);

            let auditDetailsUrl = await this.InternalLinksService.getLink('GetAuditDetailsToView');

            if (!auditDetailsUrl) {

                auditDetailsUrl = await this.InternalLinksService.getLink('GetAuditDetailsToView');
            }

            this.GetAuditDetailsToView(financialPeriodHeaderId, db_Ref);

            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditsHeaderDetails = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async GetAuditDetailsToView(FinancialPeriodHeaderId, DB_Ref) {
        let promise, promiseHandler;

        var payload = {
            FinancialPeriodHeaderId: FinancialPeriodHeaderId,
            DB_Ref: DB_Ref
        }

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!payload) {
                throw new Error('The payload must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditDetailsToView');


            if (!url) {

                url = await this.InternalLinksService.getLink('GetAuditDetailsToView');
            }

            const results = await this.$http.post(url, payload);
            const { data } = results;

            this.$timeout(() => promiseHandler.resolve(data));

            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            //this.auditTokenHistory = {};
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async getAuditQueryLogsById(auditsHeaderId) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!auditsHeaderId) {
                throw new Error('AuditsHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditQueryLogsById');

            if (!url) {

                url = await this.InternalLinksService.getLink('GetAuditQueryLogsById');
            }
            url = `${url}?auditsHeaderId=${auditsHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;

            this.auditsQueryLogs = this._map(data);
   
            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditsQueryLogs = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getAuditorByAuditorHeaderId(auditorHeaderId) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!auditorHeaderId) {
                throw new Error('auditorHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditorByAuditorHeaderId');

            if (!url) {

                url = await this.InternalLinksService.getLink('GetAuditorByAuditorHeaderId');
            }
            url = `${url}?auditorHeaderId=${auditorHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.auditorHeaderDetails = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditsQueryLogs = {};
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async getAuditorContactDetailsByAuditorHeaderId(auditorHeaderId) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!auditorHeaderId) {
                throw new Error('auditorHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditorContactDetailsByAuditorHeaderId');

            if (!url) {

                url = await this.InternalLinksService.getLink('GetAuditorContactDetailsByAuditorHeaderId');
            }
            url = `${url}?auditorHeaderId=${auditorHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.auditorContactDetails = this._map(data);

            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditorContactDetails = {};
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async getListOfAssignees() {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetListOfAssignees');

            if (!url) {

                url = await this.InternalLinksService.getLink('GetListOfAssignees');
            }

            const results = await this.$http.get(url);
            const { data } = results;
            this.listOfAssignees = this._map(data);

            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.listOfAssignees = [];
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async addAuditQuery(assignee, auditsDetails, auditQuerySubjectText, auditQueryMessageText, selectedAction, username, addQuerySelectedDoc) {

        var payload = {
            assignee: assignee,
            auditsDetails: auditsDetails,
            auditQuerySubjectText: auditQuerySubjectText,
            auditQueryMessageText: auditQueryMessageText,
            selectedAction: selectedAction,
            username: username,
            addQuerySelectedDoc: addQuerySelectedDoc
        };

        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('AddAuditQuery');

            if (!url) {

                url = await this.InternalLinksService.getLink('AddAuditQuery');
            }

            const results = await this.$http.post(url, payload);
            const { data } = results;

            this.$timeout(() => promiseHandler.resolve(data));


        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.listOfAssignees = [];
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async queryTheAuditQuery(queryLogsId, queryStatus) {


        var payload = {
            queryLogsId: queryLogsId,
            queryStatus: queryStatus
        };

        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('QueryAuditQuery');

            if (!url) {

                url = await this.InternalLinksService.getLink('QueryAuditQuery');
            }

            const results = await this.$http.post(url, payload);
            const { data } = results;
          
            this.$timeout(() => promiseHandler.resolve(data));


        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
           
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async closeTheAuditQuery(queryLogsId, queryStatus) {

        var payload = {
            queryLogsId: queryLogsId,
            queryStatus: queryStatus
        };

        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('closeAuditQuery');

            if (!url) {

                url = await this.InternalLinksService.getLink('QueryAuditQuery');
            }

            const results = await this.$http.post(url, payload);
            const { data } = results;
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);

            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getAuditQueryMessage(AuditQueryLogsId) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditQueryMessages');

            if (!url) {

                url = await this.InternalLinksService.getLink('GetAuditQueryMessages');
            }
            url = `${url}?AuditQueryLogsId=${AuditQueryLogsId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.auditsMessages = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);

            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async sendAuditQueryMessage(AuditQueryLogsId, messageText, auditor) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('SendAuditQueryMessage');

            if (!url) {

                url = await this.InternalLinksService.getLink('SendAuditQueryMessage');
            }
            url = `${url}?AuditQueryLogsId=${AuditQueryLogsId}&messageText=${messageText}&auditor=${auditor}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.auditsMessages = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);

            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async reAssignAuditQueryById(queryLogsId, reAssignee, selectedAction) {

        var payload = {
            queryLogsId: queryLogsId,
            reAssignee: reAssignee,
            selectedAction: selectedAction
        }

        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('reAssignAuditQuery');

            if (!url) {

                url = await this.InternalLinksService.getLink('reAssignAuditQuery');
            }

            const results = await this.$http.post(url, payload);
            const { data } = results;
          
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;

            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise
    }

    async saveUploadedFile(filePayload) {

        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!filePayload) {
                throw new Error('file  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('SaveUploadedFileAttachment');

            if (!url) {

                url = await this.InternalLinksService.getLink('SaveUploadedFileAttachment');
            }

            const results = await this.$http.post(url, filePayload);
            const { data } = results;
            this.auditsFile = this._map(data);

            this.$timeout(() => promiseHandler.resolve());

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditsFile = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getUploadedDocumentsByFinancialPeriodHeaderId(financialPeriodHeaderId) {

        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!financialPeriodHeaderId) {
                throw new Error('financialPeriodHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetUploadedDocumentsByFinancialPeriodHeaderId');


            if (!url) {

                url = await this.InternalLinksService.getLink('GetUploadedDocumentsByFinancialPeriodHeaderId');
            }

            url = `${url}?financialPeriodHeaderId=${financialPeriodHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.uploadedDocs = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.uploadedDocs = [];
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getExcelDocByCorrelationId(id) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('getExcelDocByCorrelationId');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('getExcelDocByCorrelationId');
            }

            url += `?id=${id}`;
            this.openNewTabReport(url, `Financial Summary Attachment`);
            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(`Couldn't load API 'links'`, err));
        }

        return promise;
    }

    openNewTabReport(url, title) {
        var win = window.open(url, '_blank');
        win.focus();

        // const newTab = window.open(url, '_blank');
        // newTab.document.write(`
        //         <title>${title}</title>
        //         <style>
        //             html:first-child>body {
        //                 margin: 0;
        //                 overflow: hidden;
        //             }
        //             iframe {
        //                 width: 100%;
        //                 height: 100%;
        //             }
        //         </style>
        //         <iframe src="${url}">
        //         </iframe>
        //     `);
    }


    _map(data) {
        if (!data) return data;

        //if (!data.IsSubmitted) {
        //    data = this._formatAndMapDate(data);
        //} else {
        //    data.ValidDate = data.ValidDate.substr(0, 10);
        //}

        //data = this._mapSellerInfo(data);
        //data = this._mapRejectedDocuments(data);

        return data;
    }
}

export default /* @ngInject */ ($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) =>
	new AuditsCaptureService($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService);
